(() => {
 const videos = new Set();
 const reduced = matchMedia('(prefers-reduced-motion: reduce)');
 const saveData = navigator.connection && navigator.connection.saveData;
 function load(v) {
   if (v.dataset.copLoaded) return;
   v.querySelectorAll('[data-src]').forEach(s => { s.src=s.dataset.src; s.removeAttribute('data-src'); });
   v.dataset.copLoaded='true'; v.load();
 }
 function play(v) {
   if (document.hidden || reduced.matches || saveData) return;
   load(v); v.muted=true; const p=v.play(); if(p) p.catch(() => {v.controls=true;});
 }
 const visible = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
   entries.forEach(({target:v,isIntersecting}) => {v.dataset.copVisible=String(isIntersecting); if(isIntersecting) play(v); else v.pause();});
 }, {threshold:0.1}) : null;
 const near = visible ? new IntersectionObserver(entries => {
   entries.forEach(({target:v,isIntersecting}) => {if(isIntersecting){if(!saveData && !reduced.matches)load(v);near.unobserve(v);}});
 }, {rootMargin:'200px'}) : null;
 function init() {
   document.querySelectorAll('video[data-cop-lazy-video]').forEach(v => {
     if(videos.has(v)) return; videos.add(v);
     v.muted=true; v.playsInline=true;
     if(saveData || reduced.matches) {v.controls=true;v.addEventListener('pointerdown',()=>load(v),{once:true});v.addEventListener('keydown',()=>load(v),{once:true});}
     if(visible){near.observe(v);visible.observe(v);}else{load(v);v.controls=true;}
   });
 }
 document.addEventListener('visibilitychange',()=>videos.forEach(v=>{if(document.hidden)v.pause();else if(v.dataset.copVisible==='true')play(v);}));
 document.addEventListener('shopify:section:load',init);
 document.addEventListener('shopify:section:unload',e=>videos.forEach(v=>{if(e.target.contains(v)){v.pause();if(visible){visible.unobserve(v);near.unobserve(v);}videos.delete(v);}}));
 init();
})();
